export const route = (state = '', action) => {
  switch(action.type) {
    case 'CHANGE_STATE':
      return action.route;
    default: return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/route.js